import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import MaterialTable from 'material-table'
import { useDispatch } from 'react-redux'
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { baseUrl } from '../../../repositories/baseUrl';
import { openNotificationWithIcon, startloader, stoploader } from '../../../Redux/Action/ActionFunction';
import { Image, Modal } from 'antd';
import axios from 'axios';
import { IconButton } from '@material-ui/core';

export default function EmployeesComp() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { confirm } = Modal;
    let Token = localStorage.getItem("token");

    const [Id, setId] = useState("");
    const [FirstName, setFirstName] = useState("");
    const [LastName, setLastName] = useState("");
    const [Email, setEmail] = useState("");
    const [Phone, setPhone] = useState("");
    const [Password, setPassword] = useState("");

    const [ProfileImage, setProfileImage] = useState("/app-assets/images/profile.jpg");
    const [SelectProfileImage, setSelectProfileImage] = useState(null)
    const [UpdateProfileImage, setUpdateProfileImage] = useState(null)

    const [ModalTitle, setModalTitle] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = (e) => {
        if (e === "Add Employee") {
            emptyStates()
        }
        setIsModalOpen(true);
        setModalTitle(e)
    };

    const handleOk = () => {
        setIsModalOpen(false);
        if (ModalTitle === "Add Employee") {
            AddEmployee();
        } else {
            UpdateEmployee()
        }
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const handleInputChange = (e, func) => {
        func(e.target.value);
    }

    const handleInputFileChange = (event, func) => {
        var file = event.target.files[0];
        var reader = new FileReader();
        var url = reader.readAsDataURL(file);
        // console.log(url)
        reader.onloadend = function (e) {
            setSelectProfileImage(reader.result);
            setUpdateProfileImage(file);
        };
        func(file)
    }

    const [Data, setData] = useState([])

    useEffect(() => {
        getData()
    }, [])

    const getData = () => {
        dispatch(startloader())
        axios({
            method: 'get',
            url: `${baseUrl.Base_Url}/view/all/emp`,
            headers: { Authorization: `Bearer ${Token}` },
        }).then(function (response) {
            dispatch(stoploader())
            const Data = response.data
            if (Data.status) {
                setData(Data.data)
            } else {
                openNotificationWithIcon("warning", "Opps", Data.message);
            }
        }).catch((error) => {
            const Err = error.response
            dispatch(stoploader())
            if (Err !== undefined) {
                if (Err.data.errors) {
                    const Data = Err.data.errors;
                    const ErrList = Object.keys(Data);
                    ErrList.map((e) => {
                        openNotificationWithIcon("warning", "Opps", Data[e][0]);
                    });
                } else {
                    openNotificationWithIcon("error", "Opps", Err.data.message);
                    if (Err.data.message === "Unauthenticated.") {
                        // dispatch(authLogout());
                        navigate('/admin/login')
                    }
                }
            } else {
                openNotificationWithIcon("error", "Opps", error.message);
            }
        });
    }

    const emptyStates = () => {
        setId("")
        setFirstName("")
        setLastName("")
        setEmail("")
        setPhone("")
        setPassword("")
        setSelectProfileImage(null)
        setUpdateProfileImage(null)
    }

    const AddEmployee = () => {
        dispatch(startloader())
        const formData = new FormData()
        formData.append("first_name", FirstName)
        formData.append("last_name", LastName)
        formData.append("email", Email)
        formData.append("phone", Phone)
        formData.append("password", Password)
        if (UpdateProfileImage) {
            formData.append("file", UpdateProfileImage)
        }
        axios({
            method: 'post',
            url: `${baseUrl.Base_Url}/add/new/emp`,
            data: formData,
            headers: { Authorization: `Bearer ${Token}` },
        }).then(function (response) {
            dispatch(stoploader())
            const Data = response.data
            if (Data.status) {
                setData(Data.data)
                emptyStates()
                openNotificationWithIcon("success", 'Congratulations!', Data.message);
            } else {
                showModal("Add Employee")
                openNotificationWithIcon("warning", 'Opps!', Data.message);
            }
        }).catch((error) => {
            showModal("Add Employee")
            const Err = error.response
            dispatch(stoploader())
            if (Err !== undefined) {
                if (Err.data.errors) {
                    const Data = Err.data.errors;
                    const ErrList = Object.keys(Data);
                    ErrList.map((e) => {
                        openNotificationWithIcon("warning", "Opps", Data[e][0]);
                    });
                } else {
                    openNotificationWithIcon("error", "Opps", Err.data.message);
                    if (Err.data.message === "Unauthenticated.") {
                        // dispatch(authLogout());
                        navigate('/admin/login')
                    }
                }
            } else {
                openNotificationWithIcon("error", "Opps", error.message);
            }
        });
    }

    const handleUpdate = (Data) => {
        // console.log("Data", Data);
        setId(Data.id)
        setFirstName(Data.first_name)
        setLastName(Data.last_name)
        setEmail(Data.email)
        setPhone(Data.phone)
        setSelectProfileImage(baseUrl.Image_Url + Data.image_path)
        showModal("Edit Employee")
    }

    const UpdateEmployee = () => {
        dispatch(startloader())
        const formData = new FormData()
        formData.append("id", Id)
        formData.append("first_name", FirstName)
        formData.append("last_name", LastName)
        formData.append("email", Email)
        formData.append("phone", Phone)
        if (UpdateProfileImage) {
            formData.append("file", UpdateProfileImage)
        }
        axios({
            method: 'post',
            url: `${baseUrl.Base_Url}/update/employee`,
            data: formData,
            headers: { Authorization: `Bearer ${Token}` },
        }).then(function (response) {
            dispatch(stoploader())
            const Data = response.data
            if (Data.status) {
                setData(Data.data)
                emptyStates()
                openNotificationWithIcon("success", 'Congratulations!', Data.message);
            } else {
                showModal("Edit Employee")
                openNotificationWithIcon("warning", 'Opps!', Data.message);
            }
        }).catch((error) => {
            showModal("Edit Employee")
            const Err = error.response
            dispatch(stoploader())
            if (Err !== undefined) {
                if (Err.data.errors) {
                    const Data = Err.data.errors;
                    const ErrList = Object.keys(Data);
                    ErrList.map((e) => {
                        openNotificationWithIcon("warning", "Opps", Data[e][0]);
                    });
                } else {
                    openNotificationWithIcon("error", "Opps", Err.data.message);
                    if (Err.data.message === "Unauthenticated.") {
                        // dispatch(authLogout());
                        navigate('/admin/login')
                    }
                }
            } else {
                openNotificationWithIcon("error", "Opps", error.message);
            }
        });
    }

    const DeleteConfirm = (id) => {
        confirm({
            icon: <ExclamationCircleOutlined />,
            content: <span>Are You Sure you want to delete this Employee?</span>,
            centered: true,
            onOk() {
                DeleteEmployee(id);
            },
            onCancel() {
                console.log('Cancel');
            },
        })
    }

    const DeleteEmployee = (id) => {
        dispatch(startloader())
        axios({
            method: 'post',
            url: `${baseUrl.Base_Url}/del/emp/${id}`,
            headers: { Authorization: `Bearer ${Token}` },
        }).then(function (response) {
            dispatch(stoploader())
            const Data = response.data
            if (Data.status) {
                setData(Data.data)
                openNotificationWithIcon("success", 'Congratulations!', Data.message);
            } else {
                openNotificationWithIcon("warning", 'Opps!', Data.message);
            }
        }).catch((error) => {
            const Err = error.response
            dispatch(stoploader())
            if (Err !== undefined) {
                if (Err.data.errors) {
                    const Data = Err.data.errors;
                    const ErrList = Object.keys(Data);
                    ErrList.map((e) => {
                        openNotificationWithIcon("warning", "Opps", Data[e][0]);
                    });
                } else {
                    openNotificationWithIcon("error", "Opps", Err.data.message);
                    if (Err.data.message === "Unauthenticated.") {
                        // dispatch(authLogout());
                        navigate('/admin/login')
                    }
                }
            } else {
                openNotificationWithIcon("error", "Opps", error.message);
            }
        });
    }

    return (
        <div className="app-content content">
            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-md-6 col-12 mb-2 breadcrumb-new">
                        <h3 className="content-header-title mb-0 d-inline-block">All Employees</h3>
                        <div className="row breadcrumbs-top d-inline-block">
                            <div className="breadcrumb-wrapper col-12">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/admin/dashboard">Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to={"/admin/employees"}>Employees</Link>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    {/* <div className="content-header-right col-md-6 col-12">
                        <a className="btn btn-md btn-danger box-shadow-2 round btn-min-width pull-right" href="#" >Add New Ad</a>
                    </div> */}
                </div>

                <div className="content-body">
                    {/* Basic Tables start */}
                    <div className="row">
                        <div className="col-md-12 text-right mb-1">
                            <button className='btn btn-primary mx-1' onClick={() => showModal("Add Employee")}>Add Employee</button>
                        </div>
                        <div className="col-12">
                            <div className="card-content collapse show">
                                <MaterialTable
                                    columns={[
                                        {
                                            title: 'Image', field: 'images',
                                            render: rowData => (
                                                <Image src={baseUrl.Image_Url + rowData.image_path} style={{ width: 50, height: 50, borderRadius: '50%' }} />
                                            )
                                        },
                                        { title: 'First Name', field: 'first_name' },
                                        { title: 'Last Name', field: 'last_name' },
                                        { title: 'Email', field: 'email' },
                                        { title: 'Phone', field: 'phone' },
                                    ]}
                                    data={Data}
                                    actions={[
                                        {
                                            icon: 'edit',
                                            tooltip: 'Edit',
                                            onClick: (event, rowData) => {
                                                handleUpdate(rowData)
                                            }
                                        },
                                        {
                                            icon: 'delete',
                                            tooltip: 'Delete',
                                            onClick: (event, rowData) => {
                                                DeleteConfirm(rowData.id)
                                            }
                                        }
                                    ]}
                                    options={{
                                        actionsColumnIndex: -1
                                    }}
                                    title=""
                                />
                            </div>
                        </div>
                    </div>
                    {/* Basic Tables end */}
                </div>
            </div>
            <Modal title={ModalTitle} width={800} open={isModalOpen} onOk={handleOk} okText={ModalTitle === "Add Employee" ? "Add" : "Edit"} onCancel={handleCancel}>
                <div className="row">
                    <div className="col-md-12 text-center">
                        <input
                            accept="image/*"
                            style={{ display: "none" }}
                            id="icon-button-file"
                            type="file"
                            onChange={(e) => handleInputFileChange(e, setProfileImage)}
                        />
                        <label htmlFor="icon-button-file">
                            <IconButton
                                color="#414141"
                                aria-label="upload picture"
                                component="span"
                                className="upload_photo_main"
                            >
                                <img style={{ minWidth: "120px", maxWidth: "120px", borderRadius: "20px" }} src={SelectProfileImage ? SelectProfileImage : ProfileImage} className="upload_photo_main" alt="profile" />
                            </IconButton>
                        </label>
                    </div>
                </div>
                <form className="form form-horizontal" onSubmit={(e) => { e.preventDefault(); handleOk() }}>
                    <div className="form-body">
                        <h4 className="form-section"><i className="la la-eye" /> About User</h4>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group row">
                                    <label className="col-md-3 label-control" htmlFor="firstname">Fist Name</label>
                                    <div className="col-md-9">
                                        <input value={FirstName} type="text" onChange={(e) => handleInputChange(e, setFirstName)} id="firstname" className="form-control border-primary" placeholder="First Name" name="firstname" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group row">
                                    <label className="col-md-3 label-control" htmlFor="lastname">Last Name</label>
                                    <div className="col-md-9">
                                        <input type="text" value={LastName} onChange={(e) => handleInputChange(e, setLastName)} id="lastname" className="form-control border-primary" placeholder="Last Name" name="lastname" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h4 className="form-section"><i className="ft-mail" /> Contact Info &amp; Bio</h4>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group row">
                                    <label className="col-md-3 label-control" htmlFor="email">Email</label>
                                    <div className="col-md-9">
                                        <input value={Email} onChange={(e) => handleInputChange(e, setEmail)} className="form-control border-primary" type="email" placeholder="email" id="email" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group row">
                                    <label className="col-md-3 label-control" htmlFor="phone">Phone</label>
                                    <div className="col-md-9">
                                        <input value={Phone} onChange={(e) => handleInputChange(e, setPhone)} className="form-control border-primary" type="tel" placeholder="phone" id="phone" />
                                    </div>
                                </div>
                            </div>
                            {ModalTitle === "Add Employee" ?
                                <div className="col-md-6">
                                    <div className="form-group row">
                                        <label className="col-md-3 label-control" htmlFor="password">Password</label>
                                        <div className="col-md-9">
                                            <input value={Password} onChange={(e) => handleInputChange(e, setPassword)} className="form-control border-primary" type="password" placeholder="password" id="password" />
                                        </div>
                                    </div>
                                </div>
                                :
                                null}
                        </div>
                    </div>
                </form>
            </Modal>
        </div>
    )
}
